import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import GenericTable from "components/CRPComponents/Tables/GenericTable";
import DefaultCell from "components/CRPComponents/Tables/components/DefaultCell";
import LinkCell from "components/CRPComponents/Tables/components/LinkCell";
import { ListProps } from "./types";
import { GET_ALL_QUERY, GetAllGql } from "./queries/getAll";
import { DATE_FORMATTERS } from "utils/formatDate";

function List(props: ListProps) {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <GenericTable<GetAllGql>
        initialVariables={{
          page: 1,
          perPage: 10,
          search: null,
        }}
        path={`${props.path}/feriados`}
        query={GET_ALL_QUERY}
        formatRows={(data) => data.Holidays.items}
        formatPagination={(data) => data.Holidays.paginationInfo}
        title="NOVA FERIADO"
        columnsTable={[
          {
            Header: "id",
            accessor: "id",
            Cell: ({ value }: any) => (
              <LinkCell href={`${props.path}/feriados/${value}`} value={value} />
            ),
          },
          {
            Header: "title",
            accessor: "title",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "Data",
            accessor: "holidayDate",
            Cell: ({ value }: any) => <DefaultCell value={DATE_FORMATTERS.formatDateStr(value)} />,
          },
        ]}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default List;
